(function () {
  'use strict';

  var observed = [];

  function positionCurrency(selector) {
    // Match the storefront floating controls' baseline. The Shopify preview
    // bar should not lift these controls higher than the live storefront does.
    var bottom = '40px';
    var properties = {
      position: 'fixed',
      left: '20px',
      right: 'auto',
      top: 'auto',
      bottom: bottom,
      margin: '0',
      transform: 'none',
      animation: 'none',
      'z-index': '2147482999'
    };

    Object.keys(properties).forEach(function (property) {
      if (selector.style.getPropertyValue(property) !== properties[property]) {
        selector.style.setProperty(property, properties[property], 'important');
      }
    });

    matchChatToCurrency(selector, bottom);
  }

  function matchChatToCurrency(selector, bottom) {
    var target = selector.querySelector('.buckscc-select-styled, .buckscc-select');
    var targetRect = target ? target.getBoundingClientRect() : selector.getBoundingClientRect();

    if (!targetRect.width || !targetRect.height) {
      return;
    }

    var width = Math.ceil(targetRect.width) + 'px';
    var height = Math.ceil(targetRect.height) + 'px';

    var chatBottom = parseInt(bottom, 10) || 80;
    var chatHeight = targetRect.height || 44;

    document.querySelectorAll('shopify-chat').forEach(function (chat) {
      chat.style.setProperty('--arista-floating-width', width);
      chat.style.setProperty('--arista-floating-height', height);
      chat.style.setProperty('left', '20px', 'important');
      chat.style.setProperty('right', 'auto', 'important');
      chat.style.setProperty('top', 'auto', 'important');
      chat.style.setProperty('bottom', bottom, 'important');
      chat.style.setProperty('position', 'fixed', 'important');
      chat.style.setProperty('margin', '0', 'important');
      chat.style.setProperty('transform', 'none', 'important');
      chat.style.setProperty('animation', 'none', 'important');
      chat.style.setProperty('z-index', '2147483000', 'important');

      disableChatMotion(chat, width, height);
    });

    // Keep the country selector above Chat, with Chat directly below it.
    var currencyBottom = Math.round(chatBottom + chatHeight + 8);
    selector.style.setProperty('bottom', currencyBottom + 'px', 'important');

    var shell = selector.closest('.buckscc-floating-box');
    if (shell) {
      shell.style.setProperty('left', '20px', 'important');
      shell.style.setProperty('right', 'auto', 'important');
      shell.style.setProperty('top', 'auto', 'important');
      shell.style.setProperty('bottom', currencyBottom + 'px', 'important');
    }
  }

  function disableChatMotion(chat, width, height) {
    var root = chat.shadowRoot;
    if (!root) {
      return;
    }

    root.querySelectorAll('#shopify-element-wrapper, .activator-nudge, .activator, button.activator, [class*="nudge"]').forEach(function (element) {
      element.style.setProperty('animation', 'none', 'important');
      element.style.setProperty('transition', 'none', 'important');
      element.style.setProperty('transform', 'none', 'important');
      element.style.setProperty('margin', '0', 'important');
      element.style.setProperty('top', 'auto', 'important');
      element.style.setProperty('right', 'auto', 'important');
      element.style.setProperty('bottom', 'auto', 'important');
      element.style.setProperty('left', '0', 'important');

      if (element.matches('#shopify-element-wrapper, .activator-nudge, [class*="nudge"]')) {
        element.style.setProperty('position', 'static', 'important');
        element.style.setProperty('width', width, 'important');
        element.style.setProperty('height', height, 'important');
      }

      if (element.matches('button.activator')) {
        element.style.setProperty('position', 'static', 'important');
        element.style.setProperty('width', width, 'important');
        element.style.setProperty('height', height, 'important');
      }
    });
  }

  function findCurrencySelectors() {
    document.querySelectorAll('.buckscc-floating-box .buckscc-currency-wrapper').forEach(function (selector) {
      positionCurrency(selector);

      if (observed.indexOf(selector) === -1) {
        observed.push(selector);
        var selectorObserver = new MutationObserver(function () {
          positionCurrency(selector);
        });
        // Do not observe inline style changes here: positionCurrency updates the
        // same style attribute and would otherwise create an endless mutation loop.
        selectorObserver.observe(selector, { attributes: true, attributeFilter: ['class'] });
      }
    });
  }

  function start() {
    findCurrencySelectors();
    var bodyObserver = new MutationObserver(findCurrencySelectors);
    bodyObserver.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(findCurrencySelectors, 500);
    window.setTimeout(findCurrencySelectors, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
